import type { FullReport } from "../lib/types";

export function RoadmapTimeline({ weeks }: { weeks: FullReport["roadmap30Days"] }) {
  return (
    <div className="grid gap-4 lg:grid-cols-4">
      {weeks.map((week) => (
        <article className="relative overflow-hidden rounded-[1.7rem] bg-moss p-6 text-white" key={week.week}>
          <span className="absolute right-3 top-0 font-display text-8xl text-white/5">{week.week}</span>
          <p className="mb-7 text-xs font-extrabold uppercase tracking-[.2em] text-lime">Week {week.week}</p>
          <h3 className="mb-4 font-display text-2xl">{week.focus}</h3>
          <ul className="space-y-3 text-sm text-white/75">
            {week.tasks.map((task) => <li className="border-l border-lime/50 pl-3" key={task}>{task}</li>)}
          </ul>
          <p className="mt-6 border-t border-white/10 pt-4 text-xs leading-5 text-lime">{week.expectedOutcome}</p>
        </article>
      ))}
    </div>
  );
}
